var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmforaDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1477,
    height: 543,
    viewBox: "0 0 1477 543",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1600_1763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M954.519 47.6802C940.789 126.14 835.259 161.56 699.379 177.25C435.989 207.68 58.5095 163.97 13.4395 216.32C58.5195 154.21 218.179 141.8 394.199 136.49H394.969C632.249 129.23 898.999 134.63 954.489 47.6602L954.509 47.6802H954.519Z",
    fill: "url(#paint0_linear_1600_1763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.16 123.92C1245.49 182.1 1046.12 6.27971 701.119 34.9597C614.449 42.1697 338.539 138.11 338.539 138.11C406.319 96.7297 644.089 18.2397 699.919 11.5197C750.099 5.47971 944.219 -23.8003 1175.29 43.5597H1175.4C1195.42 49.4297 1215.7 55.9697 1236.21 63.3597C1384.55 116.66 1475.16 123.92 1475.16 123.92Z",
    fill: "url(#paint1_linear_1600_1763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.16 124.679C1385.22 225.299 1168.14 185.069 985.021 177.999C927.951 175.759 874.211 176.709 828.631 186.169C993.681 110.219 1172.39 133.689 1303.97 143.789H1304.03C1381.65 149.719 1442.85 151.099 1475.16 124.649V124.669V124.679Z",
    fill: "url(#paint2_linear_1600_1763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.77 213.32C149.03 254.19 97.41 254.24 55.49 253.45C29.76 252.97 7.64 252.18 0 260.33C10.11 221.08 71.42 211.03 116.84 210.27C138.58 209.91 156.69 211.68 163.77 213.35V213.33V213.32Z",
    fill: "url(#paint3_linear_1600_1763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.52 47.6802C940.79 125.91 835.21 161.22 699.27 176.86C592.39 181.85 551.77 132.41 394.77 136.24C632.15 128.99 899.01 134.37 954.52 47.6602V47.6802Z",
    fill: "url(#paint4_linear_1600_1763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.73 43.5597C1029.76 20.7697 902.709 0.609718 701.309 34.9397C614.599 42.1497 338.539 138.1 338.539 138.1C406.369 96.7297 644.259 18.2297 700.119 11.5097C750.329 5.46972 944.549 -23.8203 1175.72 43.5497L1175.73 43.5597Z",
    fill: "url(#paint5_linear_1600_1763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.06 143.47C1194.59 141.5 1162.37 180.74 985.051 177.56V177.62C927.971 175.39 874.221 176.34 828.641 185.77C993.721 109.96 1172.46 133.38 1304.07 143.47H1304.06Z",
    fill: "url(#paint6_linear_1600_1763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.5 210.46C1433.4 198.96 1473.45 158.88 1473.45 158.88C1484.97 206.58 1466.97 244.82 1339.5 210.46Z",
    fill: "url(#paint7_linear_1600_1763)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.38 538.619L1375.43 285.649H1433.57L1476.39 538.619H1423.36L1411.97 477.729H1318.87L1282.73 538.619H1225.38ZM1335.75 436.879H1413.14L1395.85 335.139L1335.75 436.879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.44 538.619L1061.86 285.649H1183.24C1209.95 285.649 1229.07 293.379 1240.59 308.829C1252.37 324.019 1255.39 344.579 1249.62 370.499C1246.22 387.519 1238.88 402.319 1227.62 414.889C1216.62 427.459 1202.22 436.229 1184.41 441.209C1187.81 444.609 1190.3 448.279 1191.87 452.209C1193.7 456.139 1195.27 461.369 1196.58 467.919L1212.29 538.629H1157.3L1141.58 470.669C1140.27 464.909 1138.31 460.849 1135.69 458.489C1133.07 456.129 1128.09 454.959 1120.76 454.959H1079.12L1061.44 538.629H1008.41L1008.44 538.619ZM1088.58 410.959H1143.18C1157.06 410.959 1168.58 407.949 1177.75 401.929C1186.91 395.639 1192.94 385.169 1195.82 370.499C1198.96 356.359 1198.31 346.009 1193.86 339.469C1189.67 332.919 1179.59 329.649 1163.61 329.649H1105.87L1088.59 410.959H1088.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.319 542.549C808.559 542.549 780.669 531.949 763.649 510.729C746.629 489.249 742.699 456.779 751.869 413.319C761.819 366.969 778.709 333.449 802.539 312.759C826.639 292.069 860.149 281.729 903.099 281.729C942.899 281.729 971.059 292.069 987.559 312.759C1004.32 333.449 1007.72 366.969 997.769 413.319C988.599 456.789 971.969 489.259 947.879 510.729C923.789 531.939 890.269 542.549 847.319 542.549ZM857.139 497.379C880.969 497.379 899.819 490.569 913.699 476.949C927.579 463.069 937.659 441.859 943.949 413.319C948.659 391.579 950.239 374.429 948.659 361.859C947.349 349.289 942.239 340.389 933.339 335.149C924.429 329.649 911.079 326.899 893.269 326.899C869.439 326.899 850.449 333.449 836.309 346.539C822.429 359.369 812.219 381.629 805.669 413.319C799.649 442.909 800.169 464.379 807.239 477.739C814.579 490.829 831.199 497.379 857.129 497.379H857.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.65 538.619L272.07 285.649H323.53L365.56 437.669L472.01 285.649H527.01L473.59 538.619H420.56L455.52 374.029L370.67 495.019H340.03L306.64 374.029L271.68 538.619H218.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 538.619L53.42 285.649H234.9L226.26 326.889H97.81L84.06 391.699H197.98L189.34 432.549H75.42L61.67 497.749H190.12L181.48 538.609H0V538.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.289 497.77H708.759L708.289 499.99V497.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.451 326.899L602.701 391.709H716.611L707.971 432.559H594.061L585.951 470.999L585.271 474.259L580.311 497.769H580.341L571.791 538.629H518.641L572.061 285.649H753.541L744.901 326.899H616.451Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1600_1763",
    x1: 15.1095,
    y1: 123.55,
    x2: 952.839,
    y2: 140.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36B56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1600_1763",
    x1: 797.959,
    y1: 97.6897,
    x2: 1426.03,
    y2: 228.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D56555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1600_1763",
    x1: 1058.45,
    y1: 168.709,
    x2: 1461.49,
    y2: 146.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF775E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3221"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1600_1763",
    x1: 79.68,
    y1: 216.36,
    x2: 84.17,
    y2: 258.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1600_1763",
    x1: 395.33,
    y1: 104.8,
    x2: 5.49954,
    y2: 97.7602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C85B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A84C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1600_1763",
    x1: 339.889,
    y1: 64.1897,
    x2: 1175.07,
    y2: 79.3897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB725A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB4E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1600_1763",
    x1: 1020.71,
    y1: 155.06,
    x2: 1279.03,
    y2: 209.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE755A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1624F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1600_1763",
    x1: 1339.13,
    y1: 193.6,
    x2: 1476.61,
    y2: 190.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B60A27"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1600_1763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1476.38,
    height: 542.55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmforaDark);
export default __webpack_public_path__ + "static/media/emfora_dark.3a670ac5315c6f89e11de3510599207e.svg";
export { ForwardRef as ReactComponent };